// extracted by mini-css-extract-plugin
export default {"currencyRatio":"d+QhqKqwyxG-PjH4iPQsZA==","exRate":"vnPK-B4Zy60hKUf9G8NpYg=="};